var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.54925 16.0372C4.60937 16.0372 5.46876 15.1778 5.46876 14.1177C5.46876 13.0576 4.60937 12.1982 3.54925 12.1982C2.48913 12.1982 1.62973 13.0576 1.62973 14.1177C1.62973 15.1778 2.48913 16.0372 3.54925 16.0372Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8995 14.335C16.8196 14.335 17.5654 13.5891 17.5654 12.669C17.5654 11.7489 16.8196 11.003 15.8995 11.003C14.9794 11.003 14.2335 11.7489 14.2335 12.669C14.2335 13.5891 14.9794 14.335 15.8995 14.335Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.3783 5.93257C15.1384 5.93257 15.7546 5.3164 15.7546 4.55631C15.7546 3.79623 15.1384 3.18005 14.3783 3.18005C13.6182 3.18005 13.0021 3.79623 13.0021 4.55631C13.0021 5.3164 13.6182 5.93257 14.3783 5.93257Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M2.03706 11.3517C3.16208 11.3517 4.0741 10.4619 4.0741 9.36428C4.0741 8.26668 3.16208 7.37689 2.03706 7.37689C0.91203 7.37689 1.52588e-05 8.26668 1.52588e-05 9.36428C1.52588e-05 10.4619 0.91203 11.3517 2.03706 11.3517Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.88896 18.4999C8.91171 18.4999 9.74082 17.692 9.74082 16.6954C9.74082 15.6988 8.91171 14.8909 7.88896 14.8909C6.8662 14.8909 6.03709 15.6988 6.03709 16.6954C6.03709 17.692 6.8662 18.4999 7.88896 18.4999Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.6481 17.7093C13.6197 17.7093 14.4074 16.9423 14.4074 15.9963C14.4074 15.0502 13.6197 14.2833 12.6481 14.2833C11.6765 14.2833 10.8889 15.0502 10.8889 15.9963C10.8889 16.9423 11.6765 17.7093 12.6481 17.7093Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.2408 6.73633C5.41696 6.73633 6.37042 5.80563 6.37042 4.65756C6.37042 3.50949 5.41696 2.5788 4.2408 2.5788C3.06465 2.5788 2.11119 3.50949 2.11119 4.65756C2.11119 5.80563 3.06465 6.73633 4.2408 6.73633Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16.4259 9.88506C17.2953 9.88506 18 9.19339 18 8.34017C18 7.48696 17.2953 6.79529 16.4259 6.79529C15.5566 6.79529 14.8519 7.48696 14.8519 8.34017C14.8519 9.19339 15.5566 9.88506 16.4259 9.88506Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52523 4.99095C10.7654 4.99095 11.7707 3.98561 11.7707 2.74547C11.7707 1.50533 10.7654 0.5 9.52523 0.5C8.28509 0.5 7.27975 1.50533 7.27975 2.74547C7.27975 3.98561 8.28509 4.99095 9.52523 4.99095Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingWhite);
export default __webpack_public_path__ + "static/media/loading-white.431b8a1166fe8981862203e5bd12bec6.svg";
export { ForwardRef as ReactComponent };